import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setPlaybookType } from 'modules/playbook/actions'
import PickBot from "layouts/OnboardingPlaybookPickBotStep"

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setPlaybookType,
  }, dispatch)
})

export default connect(null, mapDispatchToProps)(PickBot)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/PickBotStep/index.js